export default "__VITE_ASSET__d05af15b__"